import { pickupOrdersTypes } from './actionTypes';

const INIT_STATE = {
  data: [],
  milestoneConfig: [],
  CountItems: 0,
  isLoading: false,
  error: {},
};

const pickupOrders = (state = INIT_STATE, action: any) => {
  switch (action.type) {
    case pickupOrdersTypes.GET_PICKUP_ORDERS:
      return {
        ...state,
        isLoading: true,
      };
    case pickupOrdersTypes.GET_PICKUP_ORDERS_SUCCESS:
      return {
        ...state,
        data: action.payload.pickupOrdersData,
        CountItems: action.payload.CountItems,
        isLoading: false,
      };

    case pickupOrdersTypes.GET_PICKUP_ORDERS_FAIL:
      return {
        ...state,
        error: action.payload,
        isLoading: false,
      };

    case pickupOrdersTypes.GET_MILESTONESCONFIG_PK_SUCCESSS:
        return{
          ...state,
          milestoneConfig: action.payload
        }
  
    case pickupOrdersTypes.GET_MILESTONESCONFIG_PK_FAIL:
          return{
            ...state,
            error: action.payload,
          }

    default:
      return state;
  }
};

export default pickupOrders;
